<template>
  <extensions-permission-guard :situationId="situationId">
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-btn color="primary" class="mb-4" dark tile to="/admin/products/new">
          新規商品作成
        </v-btn>
        <v-btn color="primary" class="ml-4 mb-4" dark tile to="/admin/products/bulk_registration">
          商品一括登録
        </v-btn>
        <v-form @submit.prevent="searchProducts">
          <v-layout row>
            <v-text-field
              v-model="searchQuery.id_eq"
              label="商品ID"
              style="max-width: 150px"
              type="number"
              clearable
              class="ma-2"
            />
            <v-text-field
              v-model="searchQuery.identification_code_cont"
              label="商品コード"
              style="max-width: 200px"
              clearable
              class="ma-2"
            />
            <v-text-field
              v-model="searchQuery.name_cont"
              label="商品名"
              style="max-width: 350px"
              clearable
              class="ma-2"
            />
            <v-btn
              color="primary"
              dark
              tile
              outlined
              class="ma-2"
              type="submit"
              @click="searchProducts"
              @submit.prevent="searchProducts"
            >
              検索
            </v-btn>
          </v-layout>
        </v-form>

        <ProductTable :products="products" />

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </extensions-permission-guard>
</template>

<script>
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import { PRODUCTS_SITUATION_ID } from '@/mixins/site_permission_utils'
import ProductTable from '@/components/commons/ProductTable'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  name: 'Product',
  components: { ProductTable, ExtensionsPermissionGuard, InfiniteLoading },
  mixins: [headUtilsMixin],
  data () {
    return {
      pageTitle: '商品管理',
      situationId: PRODUCTS_SITUATION_ID,
      products: [],
      page: 1,
      searchQuery: {
        id_eq: '',
        name_cont: '',
        identification_code_cont: ''
      },
      infiniteId: +new Date()
    }
  },
  methods: {
    searchProducts () {
      this.page = 1
      this.products = []
      this.infiniteId++
    },
    infiniteHandler ($state) {
      axios
        .get('/api/products', {
          params: {
            page: this.page,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedProducts = deserialize(data).data

          if (fetchedProducts.length > 0) {
            this.page++
            this.products = this.products.concat(fetchedProducts)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
}
</script>
